<template>
  <div id="app">
      <router-view/>
  </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>

<style>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html, body {
    height: 100%;
    background-color: #f5f5f5;
}

#app {
    width: 100%;
    min-height: 100vh;
    margin: 0 auto;
    background-color: #ffffff;
    transition: all 0.2s;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
}

@media (min-width: 641px) {
    #app {
        width: 640px;
        box-shadow: 0 0 30px rgba(0, 0, 0, 0.15);
        min-height: 100vh;
    }
}

/**
 * 修改vant toast的样式
 */
.van-toast__icon {
    font-size: 42px !important;  /* 默认 36px，可试 44~52 */
}

.van-toast {
    min-width: 100px !important;
}
</style>
